import React from 'react'
import { string } from 'prop-types'

const Addiction = ({ color, ...rest }) => (
  <svg viewBox="0 0 17 17" fill="none" {...rest}>
    <path
      d="M6.81713 7.64374L2.63932 1.07861C0.427542 2.69356 -0.169287 5.78303 1.30523 8.17035C2.25314 9.67998 3.86809 10.5928 5.65858 10.6279C5.7639 9.71509 6.04476 8.80229 6.57137 7.99481C6.64159 7.85438 6.7118 7.74906 6.81713 7.64374Z"
      fill={color}
    />
    <path
      d="M10.2931 2.48288C9.52074 1.28922 8.36219 0.446638 6.99299 0.130669C5.72911 -0.150191 4.46524 0.0253466 3.3418 0.622176L7.34406 6.97665C8.32708 5.92343 9.66117 5.29149 11.1357 5.15106C11.0655 4.23826 10.7846 3.32546 10.2931 2.48288Z"
      fill={color}
    />
    <path
      d="M16.1915 14.0683C17.666 11.7161 17.0692 8.59151 14.8574 6.97656L9.20508 15.8939C9.97745 16.3152 10.82 16.5258 11.6977 16.5258C13.5233 16.5258 15.2085 15.613 16.1915 14.0683Z"
      fill={color}
    />
    <path
      d="M8.57214 15.4728L14.2245 6.52036C13.4521 6.09907 12.6095 5.88843 11.7318 5.88843C9.90623 5.88843 8.22106 6.80123 7.23805 8.38107C5.72842 10.7684 6.32525 13.8579 8.57214 15.4728Z"
      fill={color}
    />
  </svg>
)

Addiction.propTypes = {
  color: string
}

export default Addiction
